import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	wrapper: {
		border: "1px dashed #d1d5db",
		borderRadius: "4px",
		padding: "24px",
		textAlign: "center",
		backgroundColor: "#fafafa",
	},
	heading: {
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: "15px",
		marginBottom: "8px",
	},
	body: {
		fontFamily: "Roboto",
		fontSize: "13px",
		color: "#6b7280",
	},
}));

const ReportSubscriptionsEmptyState = () => {
	const { classes } = useStyles();
	return (
		<div className={classes.wrapper}>
			<Typography className={classes.heading}>
				No report subscriptions yet.
			</Typography>
			<Typography className={classes.body}>
				Get PDF and Excel reports delivered to your inbox on a schedule. Go to
				any Defects, Services, or report page and choose &ldquo;Schedule an
				email report&rdquo; from the report menu.
			</Typography>
		</div>
	);
};

export default ReportSubscriptionsEmptyState;
